import React, { Component } from 'react';
import { connect } from 'react-redux';

import getQuantities from 'selectors/exchange/getQuantities';

import StateChangeButtonComponent from './StateChangeButtonComponent';

// export function StateChangeButtonContainer({ by, disabled, onClick }) {
export class StateChangeButtonContainer extends Component {
  isDisabled = () => {
    const {
      by,
      maxAmount,
      sellAmount,
    } = this.props;

    // If this is a positive increment, then we're disabled if we are at (or above) the cap
    if (by > 0) {
      return sellAmount >= maxAmount;
    }

    // Otherwise, we're disabled if we're at or below 0
    return sellAmount <= 0;
  }

  render = () => {
    const {
      by,
      onClick,
      sellAmount,
    } = this.props;

    return (
      <StateChangeButtonComponent
        by={by}
        disabled={this.isDisabled()}
        onClick={onClick}
        sellAmount={sellAmount}
      />
    );
  }
}

const mapStateToProps = (state, props) => {
  const { exchange: { activeItem } } = state;
  return {
    activeItem,
    buying: activeItem.forSale,
    quantities: getQuantities(state, props),
  };
};

export default connect(mapStateToProps)(StateChangeButtonContainer);